import { render, staticRenderFns } from "./ScreenPessario.vue?vue&type=template&id=0efa4d1f&scoped=true&"
import script from "./ScreenPessario.vue?vue&type=script&lang=js&"
export * from "./ScreenPessario.vue?vue&type=script&lang=js&"
import style0 from "./ScreenPessario.vue?vue&type=style&index=0&id=0efa4d1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efa4d1f",
  null
  
)

export default component.exports